import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }

  &:hover {
    background: var(--surface-hover);
  }
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const StyledFavicon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  flex-shrink: 0;
`;

export const LinkUrl = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LoadingContainer = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }
`;

export const AccordionItemLoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '20px',
        borderRadius: '8px',
      },
    },
  ],
})``;
